module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "testimonial-dominic-hamdy-mobile.795bc261.webp";